import type { ReponseConfirmationMfa, ReponseEnrolementMfa, ReponseMessage } from './types.js';

/**
 * La double authentification en mode démonstration : Réglages › Sécurité et
 * la boîte d'élévation n'appellent pas l'API. L'enrôlement passe le compte de
 * démonstration en « activée », la désactivation le remet en « non activée ».
 * Le secret est public : il ne protège rien.
 */
const SECRET_DEMO = 'DEMOARTOSERADEMOARTOSERA';

const CODES_SECOURS_DEMO = Array.from(
  { length: 10 },
  (_, rang) => `DEMO0-${String(rang + 1).padStart(5, '0')}`,
);

let deuxiemeFacteurActif = false;

export function deuxiemeFacteurDemoActif(): boolean {
  return deuxiemeFacteurActif;
}

/**
 * Réponse simulée d'un `POST …/auth/2fa/<geste>` (`geste` : `/enroll`,
 * `/confirm`…), ou `undefined` hors de ces gestes.
 */
export function reponseDeuxFacteursDemo(geste: string, methode: string): unknown | undefined {
  if (methode !== 'POST') return undefined;
  switch (geste) {
    case '/enroll':
      return {
        secret: SECRET_DEMO,
        otpauth: `otpauth://totp/Artosera:demonstration?secret=${SECRET_DEMO}&issuer=Artosera`,
      } satisfies ReponseEnrolementMfa;
    case '/confirm':
      deuxiemeFacteurActif = true;
      return { codesSecours: CODES_SECOURS_DEMO } satisfies ReponseConfirmationMfa;
    case '/backup-codes':
      return { codesSecours: CODES_SECOURS_DEMO } satisfies ReponseConfirmationMfa;
    case '/disable':
      deuxiemeFacteurActif = false;
      return { message: 'Double authentification désactivée.' } satisfies ReponseMessage;
    case '/verify':
      return { verifie: true };
    default:
      return undefined;
  }
}
